import { render, staticRenderFns } from "./wallet-info.vue?vue&type=template&id=984cf0b0&scoped=true"
import script from "./wallet-info.vue?vue&type=script&lang=js"
export * from "./wallet-info.vue?vue&type=script&lang=js"
import style0 from "./wallet-info.vue?vue&type=style&index=0&id=984cf0b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984cf0b0",
  null
  
)

export default component.exports